// Feature flags del frontend
// Mantener simple y en JS para seguir la convención del proyecto

export const FEATURES = {
  ASISTENTE_VENTAS_ENABLED: true, // activar/desactivar panel de asistente en pre-venta
  IA_ENABLED: false, // IA real desactivada; se usa fallback local
};



